<template>
  <div class="stateInventory responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader title="Sales Summary" :links="[
        { name: 'home', label: 'Home' },
        { name: 'reports', label: 'Reports' },
        { name: 'salesReport', label: 'Sales' },
        {
          name: 'salesSummary',
          label: 'Sales Summary',
        },
      ]" @export="exportToCsv" :disableExport="!reportData" />
      <br class="no-print" />
      <ReportFilter class="no-print" :filterByTime="true" @submit-filter="performGetReport" :isLoading="isLoading"
        :percentage="percentageCompleted" />
      <div class="report-container">
        <!-- This could be a component -->
        <div class="report-body" v-if="reportData">
          <table id="table-report">
            <thead>
              <tr>
                <th align="left">Day</th>
                <th align="right">Total Sales</th>
                <th align="right">Recreational Sales</th>
                <th align="right">%</th>
                <th align="right">Medical Sales</th>
                <th align="right">%</th>
              </tr>
            </thead>

            <tbody>
              <tr class="report-body__row"></tr>
              <tr v-for="[day, value] in Object.entries(reportData.list)" :key="day">
                <td>{{ value.dateString }}</td>
                <td align="right">{{ Utilities.formatPrice(value.total) }}</td>
                <td align="right">
                  {{ Utilities.formatPrice(value.recreational) }}
                </td>
                <td align="right">
                  {{
                    Utilities.formatPercent(
                      (value.recreational / value.total) * 100
                    )
                  }}
                </td>
                <td align="right">
                  {{ Utilities.formatPrice(value.medical) }}
                </td>
                <td align="right">
                  {{
                    Utilities.formatPercent((value.medical / value.total) * 100)
                  }}
                </td>
              </tr>
            </tbody>
            <tr class="skip-export">
              <td colspan="100%">
                <hr class="line1" />
              </td>
            </tr>
            <tr>
              <td colspan="1">Totals</td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.total) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.recreational) }}
              </td>
              <td align="right">
                {{
                  Utilities.formatPercent(
                    (reportData.total.recreational / reportData.total.total) *
                    100
                  )
                }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.medical) }}
              </td>
              <td align="right">
                {{
                  Utilities.formatPercent(
                    (reportData.total.medical / reportData.total.total) * 100
                  )
                }}
              </td>
            </tr>
            <tr class="skip-export"></tr>
            <tr class="skip-export">
              <td colspan="100%">
                <hr class="line1" />
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/Header/Header.vue";
import { mapActions, mapGetters } from "vuex";
import ReportFilter from "@/components/ReportFilter/ReportFilter";
import Utilities from "@/lib/Utilities";
import ReportHelper from "@/lib/report/index.js";

export default {
  data() {
    return {
      Utilities,
    };
  },
  components: {
    PageHeader,
    ReportFilter,
  },
  created: function () {
    this.setPageTitle("Sales Summary");
  },
  computed: {
    ...mapGetters({
      isLoading: "reports/isLoading",
      getData: "reports/getData",
      percentageCompleted: 'reports/percentageCompleted'
    }),
    reportData() {
      return this.getData;
    },
  },
  methods: {
    ...mapActions({
      generateReport: "reports/generate",
      clearData: "reports/clearData",
    }),
    exportToCsv() {
      var table = document.getElementById("table-report");
      ReportHelper.exportToExcel(table, "salesSummary");
    },
    performGetReport(filter) {
      let reportType = "salesSummary";
      this.generateReport({
        reportType,
        ...filter,
      });
    },
  },
  beforeDestroy() {
    this.clearData()
  }
};
</script>

<style lang="scss">
@import "./_salesSummary.scss";
</style>
